// Entry shims, loaded before anything else in src/index.tsx.
//
// Dependency code is not run through babel-loader (it excludes node_modules), so
// a vendor chunk that uses a modern built-in ships it unpolyfilled. Datadog issue
// 556454ba was "Object.hasOwn is not a function" in an older in-app webview,
// taking down the public job page at the root error boundary.
if (!Object.hasOwn) {
  Object.defineProperty(Object, 'hasOwn', {
    configurable: true,
    value(object: object, property: PropertyKey): boolean {
      return Object.getOwnPropertyDescriptor(object, property) !== undefined;
    },
    writable: true,
  });
}
